import { getCookie } from "cookies-next";
import { getSession, signOut } from "next-auth/react";
import { CookieNameEnum } from "../constants/cookie-names";
import { assertJwtCompactSerialization, jwtExpiredClient } from "./jwt";
import { MSG_EXPIRED_SESSION } from "../constants/not-allowed-apm-messages";

/** Obtém token do cookie, caso não houver, chama o ``next-auth`` retornando o token mais atualizado. 
 * 
 * Se o token estiver inválido ou expirado, chama o ``signOut`` para limpar a sessão e deslogar.
*/
export async function getUserToken() {
    const userTokensCookie = getCookie(CookieNameEnum.UserAccessTokens)

    if (userTokensCookie) {
        const userTokens = JSON.parse(userTokensCookie as string)

        if (userTokens?.accessToken) {
            const expired = await jwtExpiredClient(userTokens.accessToken)

            if (!expired)
                return userTokens.accessToken as string
        }
    }

    const data = await getSession() // Chama o jwt na api/auth/[...nextauth], que posteriormente chama session.

    if (data?.accessToken) {
        assertJwtCompactSerialization(data.accessToken)
        return data.accessToken
    }

    if (data?.error)
        console.warn(data.error)

    await signOut({ redirect: false })

    throw Error(MSG_EXPIRED_SESSION)
}